import { useState, useEffect } from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

import { isNull } from '../../izUtils';
import DisplayHistory from '../../helpers/DisplayHistory';
import DictionaryInfoButton from '../dictionary/DictionaryInfoButton';

const Checkbox = ({data, onChange, showErrors, lsFilterName, component, history, showDictionary}) => {
    const { name, display, errors, title, disabled, mandatory} = data;
    const isFilter = !isNull(lsFilterName)

    const [value, setValue] = useState("")

    useEffect(() => {
        setValue(isNull(data.value) ? false : data.value)
    }, [data.value])

    const handleChange = () => {
        setValue(!value);

        // Save filter data to LS, so it can be used if user clicks "Confirm" button
        if (isFilter) {
            let lsFilter = JSON.parse(localStorage.getItem(lsFilterName))
            if (!isNull(lsFilter)) {
                for (const filterName in lsFilter) {
                    if (filterName === name) {
                        lsFilter[filterName].value = !value;
                        localStorage.setItem(lsFilterName, JSON.stringify(lsFilter))
                    }
                }
            }
        } else {
            onChange(!value, name);
        }
    }

    if (display) {
        return (
            <FormGroup className={isFilter ? 'mt-4 mb-0 ' : ''}>
                <div className="mb-3">
                    <div className="custom-control custom-checkbox form-check">
                        <div className="form-checkbox-group mb-1">
                            <Input
                                className={"custom-control-input"}
                                id={name + (isNull(component) ? '' : '-' + component.id)}
                                type="checkbox"
                                onChange={handleChange}
                                checked={value}
                                disabled={disabled}
                            />
                            <Label className="checkmark" htmlFor={name + (isNull(component) ? '' : '-' + component.id)}></Label>

                            <div className="d-flex align-items-center">
                                <Label className="custom-control-label" htmlFor={name + (isNull(component) ? '' : '-' + component.id)} style={{ cursor: 'pointer' }} >{title + (mandatory ? " *" : "")}</Label>
                                {(showDictionary && showDictionary.fields?.includes(name)) &&
                                    <DictionaryInfoButton code={`${showDictionary.form}.${isFilter ? 'filter' : 'form'}.${name}`} id={`${showDictionary.form}.${isFilter ? 'filter' : 'form'}.${name}`} marginBottom="0.2rem" />
                                }
                            </div>

                            <div className="invalid-feedback">{"Example invalid feedback text"}</div>
                        </div>
                    </div>
                    {(!isNull(history) && history.length > 0) && <DisplayHistory history={history} data={data} />}
                </div>
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 && <div style={{ color: "red", marginBottom: "10px" }}>{errors.map((error, index) => <div key={"error-"+index}>{error}</div>)}</div>}
            </FormGroup>
        )
    } else {
        return null;
    }
}

export default Checkbox